<template>
  <b-modal
    v-model="localShow"
    title="New Seasonality"
    hide-footer
    @hidden="resetForm"
  >
    <div class="form-group">
      <label>Name</label>
      <b-form-input
        v-model="form.name"
        placeholder="e.g., Back to School, Holiday, Summer"
      />
    </div>

    <div class="form-group">
      <label>Description <span class="text-muted">(optional)</span></label>
      <b-form-textarea
        v-model="form.description"
        rows="4"
        placeholder="Describe what we should consider for this seasonal moment..."
      />
    </div>

    <div class="d-flex justify-content-end">
      <b-button
        variant="outline-secondary"
        class="mr-2"
        @click="localShow = false"
      >
        Cancel
      </b-button>

      <b-button
        variant="primary"
        :disabled="isSaving || !form.name.trim()"
        @click="save"
      >
        <b-spinner
          v-if="isSaving"
          small
          class="mr-1"
        />
        Save Seasonality
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SeasonalityModal',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localShow: false,
      isSaving: false,
      form: {
        name: '',
        description: '',
      },
    };
  },

  watch: {
    show(value) {
      this.localShow = value;
    },

    localShow(value) {
      this.$emit('update:show', value);
    },
  },

  methods: {
    async save() {
      this.isSaving = true;

      try {
        const response = await axios.post('/seasonalities', {
          name: this.form.name,
          description: this.form.description,
        });

        if (response.data.success) {
          this.$emit('created', response.data.data);
          this.localShow = false;
          toastr.success('Seasonality created');
        }
      } catch (error) {
        console.error('Error creating seasonality:', error);
        toastr.error('Failed to create seasonality');
      } finally {
        this.isSaving = false;
      }
    },

    resetForm() {
      this.form = {
        name: '',
        description: '',
      };
      this.isSaving = false;
    },
  },
};
</script>
